export default {
  data: () => ({
    translations: {
      selectProducts: {
        el: 'Επίλεξε Προϊόντα',
        en: 'Select Products:',
        it: 'Seleziona prodotti',
      },
      productsSelected: {
        el: 'Επιλεγμένα Προϊόντα',
        en: 'products selected',
        it: 'prodotti selezionati',
      },
      pointsWon: {
        el: 'κερδισμένοι πόντοι',
        en: 'points won',
        it: 'punti vinti',
      },
      cashbackWon: {
        el: 'κερδισμένο cashback',
        en: 'cashback won',
        it: 'cashback vinto',
      },
      pointsLost: {
        el: 'χαμένοι πόντοι',
        en: 'points lost',
        it: 'punti persi',
      },
      cashbackLost: {
        el: 'χαμένο cashback',
        en: 'cashback lost',
        it: 'cashback perso',
      },
      addProducts: {
        el: 'Επίλεξε Προϊόντα',
        en: 'add products',
        it: 'Aggiungi prodotti',
      },
      orderProducts: {
        el: 'Επίλεξε Προϊόντα',
        en: 'Select Products',
        it: 'Seleziona prodotti',
      },
      searchProducts: {
        el: '',
        en: 'Search for Products',
        it: '',
      },
      noData: {
        el: 'Μη διαθέσιμο',
        en: 'No data available',
        it: 'Non disponibile',
      },
      points: {
        el: 'πόντοι',
        en: 'points',
        it: 'punti',
      },
      cashback: {
        el: 'cashback',
        en: 'cashback',
        it: 'cashback',
      },
      purchasePrice: {
        el: 'Ποσό',
        en: 'Purchase Price',
        it: "Prezzo d'acquisto",
      },
      quantity: {
        el: 'Τεμάχια',
        en: 'Quantity',
        it: 'Quantità',
      },
      selectCoupon: {
        el: '',
        en: 'Select Coupon',
        it: '',
      },
      available: {
        el: 'Διαθέσιμο',
        en: 'Available',
        it: 'A disposizione',
      },
      notAvailable: {
        el: 'Μη διαθέσιμο',
        en: 'Not available',
        it: 'Non disponibile',
      },
      amount: {
        el: 'Ποσό',
        en: 'Amount',
        it: 'Importo',
      },
      search: {
        el: 'Αναζήτηση',
        en: 'Search',
        it: 'Cerca',
      },
      products: {
        el: ' Προϊόντα ',
        en: ' Products ',
        it: ' Prodotti ',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      noResultsFound: {
        el: 'Δεν βρέθηκαν αποτελέσματα.',
        en: 'No results found',
        it: 'Nessun risultato trovato',
      },
    },
  }),
};
